export default __webpack_public_path__ + "static/media/boy1.f9c177c8.svg";